import { DisplayMode } from './../../../pages/project/project.component';
import { SubMode } from 'app/components/reports/reports.component';
import { D3DragEvent } from 'd3-drag';
import { SimpleTypedHandler, TypedHandler } from './../../../types/handlers';
import { DataManagerService, RouteTally } from './../../services/data-manager.service';
import { AnyHandler, SimpleHandler } from 'app/types/handlers';
import { RouteConfigOKHandlerParams } from './../../../components/dialogs/route-config-dialog/route-config-entry/route-config-entry.component';
import { ObjID } from 'app/model/id-manager';
import { SpatialCoord } from 'app/model/mapping/Pixospatial';
import { RoutesService } from 'app/model/services/routes.service';
import { AppInjector } from './../../../app.module';
import { RouteConfigDialogService } from './../../../components/dialogs/route-config-dialog/route-config-dialog.service';
import { getGeom } from '@turf/invariant';
import { lineString, point as pointHelper, Geometry, GeometryObject, feature } from '@turf/helpers';
import { Feature, IFeatureContext, IFeature } from './Feature';
import { PixoSpatial, PixoPt } from '../Pixospatial';

import { Segment } from './Segment';
import { RouteInfo, RouteService } from 'app/model/services/route.service';
import { nearestPointOnLine } from '@turf/turf';
import { from } from 'rxjs';
import { PointFeature } from './PointFeature';
import { SubscriptionMgr } from 'app/model/SubscriptionMgr';
import { AttributeFeatureType, AttributeId, AttributeStyle, CostKeys, Costs } from 'app/types/project-config';
import { FeatureData } from 'app/model/project';
import { Route } from 'app/types/route-data';
// tslint:disable-next-line: no-string-literal

export type RouteEnding = undefined | { end: 'segment' | 'start' | 'end' | 'middle' | undefined, feature: undefined | any };

export type AttributeTally = {
  costs: { [key in CostKeys]?: number },
  total: number;
  qty: number;
}

export type RoutePart = {
  routeId: ObjID;
  partId: ObjID;
  type: AttributeFeatureType;
  data?: FeatureData | undefined;
  id?: ObjID;
  tally?: { [key in ObjID]?: AttributeTally };
  costTally?: { [key in CostKeys]?: number }
  tallyOld?: { [key in ObjID]?: AttributeTally };
  value?: number;
  valueOld?: number;
  getLength?: SimpleTypedHandler<number>;
  style?: AttributeStyle;
}

export function AddPointRoute(route: RouteFeature | ObjID, pt: any) {
  let info: RouteInfo;
  if (route instanceof RouteFeature) {
    info = RouteService.instance.GetRoute(route.id as number);
  } else {
    info = RouteService.instance.GetRoute(route as number);
  }
  if (!info) throw new Error('Could not get route id from provided route');
  if (!pt.routes) {
    pt.routes = [] as Array<ObjID>;
  }
  if (pt.routes.indexOf(info.id) < 0) {
    pt.routes.push(info.id);
  }
  if (pt.routes.length > 1) {
    pt.routes.every((pointRoute: any) => {
      const routeInfo: any = RouteService.instance.GetRoute(pointRoute);
      if (routeInfo.feature.intersections.indexOf(pt.id) < 0) {
        routeInfo.feature.intersections.push(pt.id as ObjID);
      }
      return true;
    });

  }
}

export function RemovePointRoute(route: RouteFeature | ObjID, pt: any) {

  let info: RouteInfo;
  if (route instanceof RouteFeature) {
    info = RouteService.instance.GetRoute(route.id as number);
  } else {
    info = RouteService.instance.GetRoute(route as number);
  }
  if (!info) throw new Error('Could not get route id from provided route');
  if (!info.feature?.intersections) return;

  const ptIndex = info.feature.intersections.indexOf(pt.id as ObjID);

  if (ptIndex > -1) {
    info.feature.intersections.splice(ptIndex, 1);
  }
  const routeIndex = pt.routes.indexOf(info.id);
  if (routeIndex > -1) {
    pt.routes.splice(routeIndex, 1);
  }
}



export class RouteFeature extends Feature implements IFeature {
  public intersections: Array<ObjID> = [];
  protected dataMgr?: DataManagerService = DataManagerService.instance
  private segmentGroup: any;
  private pointGroup: any;
  public segments: Array<any>;
  private _visible: boolean = true;
  private subscrptions = new SubscriptionMgr();
  public selected = false;
  public set visible(isVisible: boolean) {
    this._visible = isVisible;
    this.segments.every((seg) => {
      seg.ui.classed('not-viz', !this._visible);
      seg.updateUI();
      return true;
    });
    let match = false;
    this.points.every((pt) => {
      pt.ui.classed('not-viz', !isVisible);
      if (!this._visible) {
        if (pt.routes && pt.routes.length > 1) {
          let visMatch = false;
          for (const rt of pt.routes) {
            const route = this.routeSvc.GetRoute(rt);
            if (route.feature?.visible === true) {
              visMatch = true;
            }
          }
          pt.ui.classed('not-viz', !visMatch);
          pt.updateUI();
        }
      }
      pt.updateUI();
      return true;
    });

  }

  public get visible(): boolean {
    return this._visible;
  }
  public set id(myId: any) {
    super.id = myId;
    this.segmentGroup.attr('data-route', myId);

    this.pointGroup.attr('data-route', myId);

  }
  public get id() {
    return super.id;
  }
  private ending = 'end';
  public get type(): string {
    return 'route';
  }
  private routes!: RouteConfigDialogService;
  private routesSvc!: RoutesService;
  private routeSvc!: RouteService;
  constructor(context: IFeatureContext, spatialContext?: PixoSpatial) {
    super(context, spatialContext);
    this.routes = AppInjector.get(RouteConfigDialogService);
    this.routesSvc = AppInjector.get(RoutesService);
    this.routeSvc = AppInjector.get(RouteService);

    this.subscrptions.Subscribe(RoutesService.onChange, (event: any) => {
      if (event.change === 'route-selected') {
        if (event.route !== this.id!) {
          this.DeselectFeature();
        }
      } else {
        if (event.route !== this.id) {
          if (!this.lastSelection) return;
          if (this.lastSelection === event.feature) return;
          const feature = this.lookup[this.lastSelection]
          if (!!feature && (feature.id !== this.id)) {
            feature.ui.classed('selected', false);
          }
        }
      }
    });
    this.segmentGroup = context.segmentGroup;
    this.pointGroup = context.pointGroup;
    this.segmentGroup.attr('data-role', 'segment-group');
    this.pointGroup.attr('data-role', 'point-group');

    this.segments = [];
    this.points = [];
    this.groups = [this.pointGroup, this.segmentGroup];
    // Feature.idFactory;
  }
  DetectEnd(): RouteEnding {
    if (!this.lastSelection) return undefined;
    if (!this.spatialContext) return undefined;
    const feature: Feature = this.lookup[this.lastSelection];
    if (feature?.type === 'segment') {
      return { end: 'segment', feature: (feature) };
    }
    if (!feature) {
      return { end: undefined, feature: feature };
    }
    let first;
    let last;
    if (this.segments.length > 0) {
      first = this.segments[0].from;
      if (first.id === feature.id) {
        return { end: 'start', feature: first };
      }
      last = this.segments.slice(-1).pop().to;
      if (last.id === feature.id) {
        return { end: 'end', feature: last };
      }
      return { end: 'middle', feature: (feature) };
    }
    return { end: 'end', feature: (feature) };
  }
  AddVertex(ptInfo: any, xProp = 'x', yProp = 'y', okHandler?: AnyHandler) {

    let fromPt = null;
    let toPt = null;
    let pt: any;
    const ending: RouteEnding = this.DetectEnd();
    if (ending) {
      switch (ending.end) {
        case 'start':
          {
            const toPt = ending.feature;
            const pt = this.MakeVertex(this.points, ptInfo, xProp, yProp);
            pt.share(this.id);
            const seg = this.MakeSegment(this.points, this.segments, pt, toPt, ending.end);
            this.Select(pt.id, this.id!);
            if (okHandler) okHandler(pt);
            return;
          }
        case 'end':
          fromPt = ending.feature;
          const pt = this.MakeVertex(this.points, ptInfo, xProp, yProp);
          pt.share(this.id);
          this.MakeSegment(this.points, this.segments, fromPt, pt, ending.end);
          this.Select(pt.id, this.id!);
          if (okHandler) okHandler(pt);
          return;
        case 'middle':
          if (!!this.routes) {
            this.routes.Show({
              cancelHandler: () => { },
              okHandler: (params: RouteConfigOKHandlerParams) => {
                const fromGeom = ending.feature;
                params.route.feature?.AddVertex(fromGeom);
                params.route.feature?.Select(fromGeom, params.route.feature.id);
                params.route.feature!.AddVertex(ptInfo, xProp, yProp, okHandler);

                return;
                /* const pixo = this.spatialContext?.PixoPt(ptInfo);
                 const geoPt = pixo!.convert();
                 const fromGeom = this.spatialContext!.PixoPt((lastSelect as Segment).fromVertex).convert();
                 const toGeom = this.spatialContext!.PixoPt((lastSelect as Segment).toVertex).convert();
                 const tLine = lineString([[fromGeom.lng, fromGeom.lat], [toGeom.lng, toGeom.lat]]);
                 const tPoint = pointHelper([geoPt.lng, geoPt.lat]);
                 const nearest = nearestPointOnLine(tLine, tPoint, { units: 'meters' });
                 const nC = nearest.geometry.coordinates;
                 const nPt: any = { x: nC[0], y: nC[1] };
                 lastSelect.AddVertex(nPt);
                 this.AddVertex(ptInfo, xProp, yProp);
                 */
              },
              addTo: this.id
            });

          }
          return;
        case 'segment':
          // Prompt for route and add to nearest point
          if (!!this.routes) {
            this.routes.Show({
              cancelHandler: () => { },
              okHandler: (params: RouteConfigOKHandlerParams) => {
                const pixo = this.spatialContext?.PixoPt(ptInfo);
                const geoPt = pixo!.convert();
                const fromGeom = ending.feature.from.coord.spatial;
                const toGeom = ending.feature.to.coord.spatial;
                const tLine = lineString([[fromGeom.lng, fromGeom.lat], [toGeom.lng, toGeom.lat]]);
                const tPoint = pointHelper([geoPt.lng, geoPt.lat]);
                const nearest = nearestPointOnLine(tLine, tPoint, { units: 'meters' });
                const nC = nearest.geometry.coordinates;
                const nSpatial: any = this.spatialContext?.SpatialCoord({ lng: nC[0], lat: nC[1] });
                const nPt = nSpatial.convert();
                const pt = ending.feature.AddVertex(nPt.x, nPt.y);
                //ending.feature.AddExistingVertex(pt);
                params.route.feature?.AddVertex(pt);
                params.route.feature?.AddVertex(ptInfo, xProp, yProp);
              },
              addTo: this.id
            });
            return;
          }


      }
    }

    // adding first point to route.
    const firstPt = this.MakeVertex(this.points, ptInfo, xProp, yProp);
    this.Select(firstPt.id, this.id!);

  }
  AddExistingVertex(vertex: any, okHandler?: AnyHandler) {

    let fromPt = null;
    let toPt = null;
    let pt: any;
    if (this.points.length < 2) {
      if (this.points.length < 1) {
        this.points.push(vertex);
        this.lookup[vertex.id] = vertex;
        this.Select(vertex.id, this.id!);
        vertex.share(this.id);
        return;
      }
    }
    const ending: RouteEnding = this.DetectEnd();
    if (ending) {
      switch (ending.end) {
        case 'start':
          {
            const toPt = ending.feature;
            const pt = vertex; //this.MakeVertex(this.points, this.pointGroup, ptInfo, xProp, yProp);
            this.points.unshift(pt);
            this.lookup[vertex.id] = vertex;
            pt.share(this.id);
            const seg = this.MakeSegment(this.points, this.segments, pt, toPt, ending.end);
            this.Select(pt.id, this.id!);
            if (okHandler) okHandler(pt);
            return;
          }
        case 'end':
          fromPt = ending.feature;
          const pt = vertex; // this.MakeVertex(this.points, this.pointGroup, ptInfo, xProp, yProp);
          pt.share(this.id);
          this.lookup[vertex.id] = vertex;
          this.points.push(pt);
          this.MakeSegment(this.points, this.segments, fromPt, pt, ending.end);
          this.Select(pt.id, this.id!);

          if (okHandler) okHandler(pt);
          return;
        case 'middle':
          if (!!this.routes) {
            this.routes.Show({
              cancelHandler: () => { },
              okHandler: (params: RouteConfigOKHandlerParams) => {
                const fromGeom = ending.feature;
                params.route.feature?.AddVertex(fromGeom);
                params.route.feature?.Select(fromGeom, params.route.feature.id);
                params.route.feature!.AddExistingVertex(vertex, okHandler);
                this.Select(vertex.id, this.id!);
                return;

              },
              addTo: this.id
            });

          }
          return;
        case 'segment':
          // Prompt for route and add to nearest point
          if (!!this.routes) {
            this.routes.Show({
              cancelHandler: () => { },
              okHandler: (params: RouteConfigOKHandlerParams) => {
                const pixo = vertex.coord.spatial; //  this.spatialContext?.PixoPt(ptInfo);
                const geoPt = pixo!.convert();
                const fromGeom = ending.feature.from.coord.spatial;
                const toGeom = ending.feature.to.coord.spatial;
                const tLine = lineString([[fromGeom.lng, fromGeom.lat], [toGeom.lng, toGeom.lat]]);
                const tPoint = pointHelper([geoPt.lng, geoPt.lat]);
                const nearest = nearestPointOnLine(tLine, tPoint, { units: 'meters' });
                const nC = nearest.geometry.coordinates;
                const nSpatial: any = this.spatialContext?.SpatialCoord({ lng: nC[0], lat: nC[1] });
                const nPt = nSpatial.convert();
                const pt = ending.feature.AddVertex(nPt.x, nPt.y);
                //ending.feature.AddExistingVertex(pt);
                params.route.feature?.AddVertex(pt);
                params.route.feature?.AddVertex(vertex);
              },
              addTo: this.id
            });
            return;
          }


      }
    }



  }

  Remove(geomOnly: boolean = false): void {
    this.DeselectFeature();
    for (let ptI = this.points.length - 1; ptI > -1; ptI--) {
      const pt = this.points[ptI];
      if (!!this.lookup[pt.id]) {

        pt.unshare(this.id);
        if (pt.routes && pt.routes.length > 0) {
          continue;
        }
        if (!!this.lookup[pt.id].ui) {
          this.lookup[pt.id].ui.on('.drag', null);
          this.lookup[pt.id].ui.on('mousedown', null);
          this.lookup[pt.id].ui.on('mouseup', null);

        }
        delete this.lookup[pt.id];


      }
      if (pt.routes && pt.routes.indexOf(this.id!)) {
        pt.routes.splice(pt.routes.indexOf(this.id!), 1);
      }
      if (pt.routes && pt.routes.length > 0) {
        continue;
      }
      pt.remove();
    }
    for (let i = this.segments.length - 1; i > -1; i--) {
      const segment = this.segments[i];
      if (!!this.lookup[segment.id]) {
        this.lookup[segment.id].ui.on('mousedown', null);
        delete this.lookup[segment.id];
      }
      segment.remove();
    }
    if (geomOnly === false) {
      this.subscrptions.CancelSubscriptions();
    }

  }
  ToGeoJSONGeom(): GeometryObject | false {
    if (this.points.length <= 1) {
      return false;
    }
    const coords = [];
    for (const pt of this.points) {
      const coord = pt.coord.spatial;
      coords.push([coord.lng, coord.lat]);
    }
    return getGeom(lineString(coords));
  }
  FromGeoJSONGeom(geom: Geometry) {
    if (!geom) return;
    if (!this.spatialContext) return;
    for (const lineCoord of (geom.coordinates as Array<[number, number]>)) {
      const ptInfo: PixoPt = this.spatialContext.SpatialCoord({ lng: lineCoord[0], lat: lineCoord[1] }).convert();
      this.AddVertex(ptInfo);

    }
  }

  SelectFeature() {
    super.SelectFeature();

  }
  Clear() {
    const geomOnly = true;
    this.Remove(geomOnly);
  }
  Select(targetId: string, routeId?: ObjID, routeSelect: true | false | 'auto' = true): void {
    this.dataMgr?.DeSelect();

    if (!routeId) routeId = this.id;
    const isEdit = this.dataMgr?.GetProject()?.viewMode === 'edit';
    const isAuto = routeSelect === 'auto';
    const select = (routeSelect === true) || (isAuto && isEdit);
    //if (select) {
      this.dataMgr?.SelectFeature(targetId as ObjID, this as RouteFeature);
    // }
    super.Select(targetId, routeId!);
  }

  SelectRoute(selectFeature: boolean = true) {
    this.selected = true;
    this.segments.every((segment) => {
      segment.ui.classed('selected-route', true);
    })
    this.points.every((point) => {
      point.ui.classed('selected-route', true);
    })
    if (selectFeature) {
      if (!this.lastSelection) {
        if (this.segments.length > 0) {
          this.Select(this.segments[0].from.id, this.id);
          return;
        }
        if (this.points.length > 0) {
          this.Select(this.points[0].id, this.id);
        }
      }
    }
  }
  DeselectRoute() {
    this.selected = false;
    this.segments.every((segment) => {
      segment.ui.classed('selected-route', false);
    });
    this.points.every((point) => {
      point.ui.classed('selected-route', false);
    });
  }
  MakeVertex(points: Array<any>, ptInfo: any, xProp: string = 'x', yProp: string = 'y', zProp: string = 'z'): any {
    const pt = super.MakeVertex(points, ptInfo, xProp, yProp, zProp);
    pt.ui.classed('selected-route', this.selected);
    const part: RoutePart = {
      routeId: this.id,
      partId: pt.id,
      type: 'point'
    }
    this.dataMgr?.MakeRoutePart(part);
    pt.partId = part.id;
    pt.updateUI(true);
    if (!!pt.share) 0
    pt.share(this.id);
    return pt;
  }
  MakeSegment(points: Array<any>, segments: Array<any>, fromPt = null, toPt = null, ending: string = 'end'): any {
    const seg = super.MakeSegment(points, segments, fromPt, toPt, ending);
    if (!seg) {
      return undefined;
    }
    // const pointGroup = this.context?.pointGroup;
    // const segmentGroup = this.context?.segmentGroup;
    seg.ui.classed('selected-route', this.selected);

    const part: RoutePart = {
      routeId: this.id,
      partId: seg.id,
      type: 'segment',
      getLength: () => {
        return Math.round(seg.length);
      }
    }
    this.dataMgr?.MakeRoutePart(part);
    seg.partId = part.id;
    return seg;
  }
  DeselectFeature(featureId?: ObjID) {
    // if (!this.lastSelection) return;
    // const lastSelection = this.lookup[this.lastSelection];
    super.DeselectFeature(featureId);
    /*lastSelection.routes.every((r: any) => {
      if (r === this.id) return true;
      const route = this.routeSvc.GetRoute(r);
      route.feature?.DeselectFeature();
      return true;
    })*/
  }
  IsSelected(): boolean {
    return this.selected;
  }
  DeselectShared() {
    if (!this.lastSelection) return;
    const feature = this.lookup[this.lastSelection]
    // this.DeselectFeature();
    if (!!feature.routes) {
      for (const rt of feature.routes) {
        if (rt === this.id) continue;
        const route = this.routeSvc.GetRoute(rt);
        if (!route) continue;
        route.feature?.DeselectFeature();

        /* if (route.feature?.IsSelected()) {
          route.feature!.lastSelection = '' + feature.id;
          route.feature?.SelectFeature();
        }*/
      }
    }
  }

  GPSAddVertex(position?: GeolocationPosition) {
    if (!navigator.geolocation) return;
    if (!this.spatialContext) return;
    if (!position) {
      navigator.geolocation.getCurrentPosition((position) => {
        if (!position) return;
        this.GPSAddVertex(position);
      });
      return;
    }
    const spatial = this.spatialContext.SpatialCoord(position.coords, 'longitude', 'latitude');
    const pixo = spatial.convert();
    this.AddVertex(pixo, 'x', 'y', (pt: any) => {
      if (!(pt && pt.coord)) return;
      pt.coord.UpdateSpatial(position.coords.longitude, position.coords.latitude,
        position.coords.accuracy, position.timestamp, position.coords.altitude, position.coords.altitudeAccuracy,
        position.coords.heading, position.coords.speed);
      this.geometryChange.emit(pt);

    });

  }
  public value: number = 0;
  public tally: RouteTally = {};

  UpdateTally(routePart: RoutePart, target: 'old' | 'current') {
    let targetTally = (target === 'old') ? routePart.tallyOld : routePart.tally;
    if (!targetTally) return;
    for (const targetKey in targetTally) {
      const tallyItem = targetTally[targetKey as any] as AttributeTally;
      if (routePart.type === 'segment') {
        tallyItem.costs['length'] = routePart.getLength!();
      }
      if (!tallyItem) continue;
      // if (!this.tally[targetKey]) continue;
      switch (target) {
        case 'old':
          /*   const item = this.tally[targetKey];
             if (!item) continue;
             for (const costKey in tallyItem) {
               let cost = item[costKey as CostKeys];
               const tallyCost = tallyItem[costKey as CostKeys];
               // if checks to placate linter; cost and tallyCost each can be undefined
               if (cost === undefined) continue;
               if (tallyCost === undefined) continue;
               item[costKey as CostKeys] = cost - tallyCost;

             }
             break;
             */
          if (!this.tally[targetKey]) {
            continue;
          }
          {
            const currentItem = this.tally[targetKey]!.costs;
            for (const costKey in tallyItem.costs) {
              const tallyCost = tallyItem.costs[costKey as CostKeys];
              if (tallyCost === undefined) continue;
              if (!currentItem[costKey as CostKeys]) {
                continue;
              }
              currentItem[costKey as CostKeys]! -= Number(tallyCost);
            }
            this.tally[targetKey]!.total -= Number(tallyItem.total);
            this.tally[targetKey]!.qty -= 1;
          }
          break;
        case 'current':
          if (!this.tally[targetKey]) {
            this.tally[targetKey] = { costs: {}, total: 0, qty: 0 };
          }
          {
            const currentItem = this.tally[targetKey]!.costs;
            for (const costKey in tallyItem.costs) {
              const tallyCost = tallyItem.costs[costKey as CostKeys];
              if (tallyCost === undefined) continue;
              if (!currentItem[costKey as CostKeys]) {
                currentItem[costKey as CostKeys] = 0;
              }
              currentItem[costKey as CostKeys]! += Number(tallyCost);

            }
            this.tally[targetKey]!.total += Number(tallyItem.total);
            this.tally[targetKey]!.qty += 1;
          }
          break;

      }


    }
  }
  UpdateValue(routePart: RoutePart, updatedRoutes?: Array<ObjID>) {
    var feature = this.dataMgr?.GetProject()?.idRegistry.Get(routePart.partId);

    if (!updatedRoutes) {
      updatedRoutes = [this.id];
    } else {
      if (updatedRoutes.indexOf(this.id) > -1) {
        return;
      } else {
        updatedRoutes.push(this.id);
      }
    }
    if (!!routePart.valueOld) {
      if (!!this.value) {
        this.value -= routePart.valueOld;
      }
    }
    if (!!routePart.value) {
      this.value += routePart.value;
    }
    for (const routeId of feature.routes) {
      if (routeId === this.id) continue;
      const route = this.dataMgr?.GetProject()?.idRegistry.Get(routeId) as RouteInfo;
      if (!!route?.feature) route.feature.UpdateValue(routePart, updatedRoutes);
    }
    this.UpdateTally(routePart, 'old');
    this.UpdateTally(routePart, 'current');
    if (!!feature.updateUI) {
      feature.updateUI(true);
    }
  }
  HandleVertexDrag(event: D3DragEvent<SVGElement, any, any>, final: boolean = false): any {
    if (this.dataMgr?.GetProject()?.drawPane?.isOn === false) {
      return false;
    }
    return super.HandleVertexDrag(event, final);

  }
  protected FeatureRemoved(feature: any) {
    if (!feature.partId) return;
    const part = this.dataMgr?.GetProject()?.idRegistry.Get(feature.partId) as RoutePart;
    if (!!part) {
      this.dataMgr?.UnTallyRoutePart(part);
      if (!!part.id) {
        this.dataMgr?.GetProject()!.idRegistry.UnRegisterID(part.id);
      }
      feature.partId = undefined;
      this.dataMgr?.FeatureUpdated();
    }

  }
  GetTally(mode: SubMode, topRouteId: ObjID, route: Route, matches?: any, tally?: RouteTally): RouteTally {
    if (!route.feature.visible) {
      if (tally) return tally;
      return {}
    }
    if (!tally) tally = JSON.parse(JSON.stringify(this.tally));

    if (!matches) matches = {};
    for (const intersect of this.intersections) {
      const pt = this.dataMgr?.GetProject()?.idRegistry.Get(intersect);
      if (!pt) continue;
      const ptRoute: Route = this.dataMgr?.GetProject()?.idRegistry.Get(pt.featureId);
      if (ptRoute) {
        if (ptRoute!.feature.visible === true) continue;
      }
      if (pt.featureId)
        // if the point was matched move along.
        if (matches[pt.id]) continue;
      // add point to matches whether we add its tally or not.
      matches[pt.id] = true;

      // don't re-add the point if it is already part of the route tally.
      if (pt.featureId === this.id) continue;
      // if we're here, then merge the point's route part tally.
      const part = this.dataMgr?.GetProject()?.idRegistry.Get(pt.partId);
      this.MergePtTally(tally!, part.tally);

    }
    // At this point any points in common are matched if they weren't before.
    // Process sub routes if appropriate
    if (!!route.children && mode === '*+') {
      for (const childId of route.children) {
        const childRoute = this.dataMgr?.GetProject()?.idRegistry.Get(childId);
        const feature: RouteFeature = childRoute.feature as RouteFeature;
        const subTally = feature.GetTally(mode, topRouteId, childRoute, matches);
        this.MergePtTally(tally!, subTally!);
      }

    }
    return tally!;
  }
  MergePtTally(targetTally: RouteTally, ptTally: RouteTally) {
    for (let key in ptTally) {
      if (!ptTally.hasOwnProperty(key)) continue;
      const tallyEntry = ptTally[key]!;
      if (!targetTally[key]) {
        targetTally[key] = JSON.parse(JSON.stringify(ptTally[key]));
        targetTally[key]!.qty = 1;
        continue;
      }
      if (tallyEntry.qty === undefined) tallyEntry.qty = 1;
      if (targetTally[key]!.qty === undefined) targetTally[key]!.qty = 0;
      targetTally[key]!.qty += !!tallyEntry.qty ? tallyEntry.qty : 0;
      targetTally[key]!.total += ptTally[key]!.total;
      if (ptTally[key]!.costs) {
        if (ptTally[key]!.costs.labor) {
          targetTally[key]!.costs.labor = Number(targetTally[key]!.costs.labor) + Number(ptTally[key]?.costs.labor);
        }
        if (ptTally[key]!.costs.materials) {
          targetTally[key]!.costs.materials = Number(targetTally[key]!.costs.materials) + Number(ptTally[key]?.costs.materials);
        }
        if (ptTally[key]!.costs.length) {
          targetTally[key]!.costs.length = Number(targetTally[key]!.costs.length) + Number(ptTally[key]?.costs.length);
        }
      }
    }
  }
}
